import * as api from './api';

export function updateFilterUrl(filter) {
    window.history.pushState(null, '', '?' + api.buildOptionalParametersArray(filter).join('&'));
}

export function getParam(key) {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.has(key) ? urlParams.get(key) : null;
}

export function getFilterFromQueryParams(filterKeys, options) {
    let filterState = {};

    filterKeys.forEach(key => {
        const searchParam = getParam(key);
        if(getParam(key)) {
            switch(key) {
                case 'additionalCategories':
                case 'categories': {
                    filterState[key] = options[key].filter(
                        item => searchParam
                            .split(',')
                            .map(item => parseInt(item, 10))
                            .includes(parseInt(item.value,10)));
                    break;
                }
                case 'date': {
                    const parts = searchParam.split('-');
                    filterState[key] = new Date(parts[2], parts[1]-1, parts[0]);
                    break;
                }
                default: {
                    filterState[key] = searchParam;
                }
            }
        }
    });

    return filterState;
}


// WEBPACK FOOTER //
// ./React/src/service/routing.js